import UAParser from 'ua-parser-js';

export const getDeviceType = (): string => {
  const parser = new UAParser();
  const result = parser.getResult();
  const deviceType = result.device.type;
  return deviceType === 'mobile' || deviceType === 'tablet' ? 'MOBILE' : 'DESKTOP';
};

const createMobileReturnUrl = (uaParserResult: any) => {
  const isChrome = uaParserResult.browser.name.match('Chrome');
  const isFirefox = uaParserResult.browser.name.match('Mozilla');
  const returnUrl = encodeURIComponent(`${window.location.origin}${window.location.pathname}`); // Dynamically get the current URL
  if (isChrome) {
    return `googlechrome://?redirect=${returnUrl}`;
  }
  if (isFirefox) {
    return `firefox://open-url?url=${returnUrl}`;
  }
  return `safari://?redirect=${returnUrl}`; // Default for Safari
};

export const getStartBankIdUrl = (autoStartToken: string) => {
  const parser = new UAParser();
  const result = parser.getResult();
  const deviceType = result.device.type;
  const isMobile = deviceType === 'mobile' || deviceType === 'tablet';

  return `bankid:///?autostarttoken=${autoStartToken}&redirect=${isMobile ? createMobileReturnUrl(result) : null}`;
};
